import { Text } from '@backstage/ui';
import { CustomDialog } from '@internal/backstage-plugin-devops-react';

interface ConfirmScanDialogProps {
  isOpen: boolean;
  /**
   * True when the confirmed action loads Azure scan result files instead of
   * starting a scan.
   */
  isLoad?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmScanDialog(props: Readonly<ConfirmScanDialogProps>) {
  return (
    <CustomDialog
      isOpen={props.isOpen}
      title={props.isLoad ? 'Confirm Load' : 'Confirm Scan'}
      submitButtonText={props.isLoad ? 'Load' : 'Start Scan'}
      cancelButtonText="Cancel"
      onClose={props.onClose}
      onSubmit={props.onConfirm}
    >
      <Text>
        {props.isLoad
          ? 'Loading the selected scan result files replaces the current resource data for this account. Do you want to continue?'
          : 'A new scan collects up-to-date resources and compliance data for this account and may take a while. Do you want to start it?'}
      </Text>
    </CustomDialog>
  );
}
